export const cibEsea = ["32 32","<path d='M18.74 4l-6.808 8.995-11.932 0.183 7.776 5.959-6.385 9.171 11.317-5.447 7.615 5.765v-9.489l11.677-5.767-23.005 5.365c0.792-0.797 1.5-1.672 2.12-2.609 0.407-0.74 0.688-1.541 0.817-2.38l7.459-0.204z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-esea.js
// module id = null
// module chunks = 